module.exports = __webpack_public_path__ + "static/media/solutions.767dfcb1.jpg";